import { render, staticRenderFns } from "./ForumSearchBody.vue?vue&type=template&id=03322a8e&scoped=true"
import script from "./ForumSearchBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSearchBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSearchBody.vue?vue&type=style&index=0&id=03322a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03322a8e",
  null
  
)

export default component.exports